import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import EditTransliteration from "./EditTransliteration";
import DatePicker from "react-datepicker";
import moment from "moment";
import { api_url } from "../../helpers/apiHelpers";
import { toast } from "react-toastify";
import googleTransliterate from "google-input-tool";

const EditPensionProposalData = ({ PPEditId, setEditDialog }) => {
  const [currentStep, setCurrentStep] = useState(0);
  const navigate = useNavigate();
  const userId = localStorage.getItem("userId");

  const [PensionProposalData, setPensionProposalData] = useState([]);
  const getPensionProposalData = async () => {
    try {
      const response = await fetch(
        `${api_url}/api/users/get-pension_proposal-data`,
        {
          method: "POST",
          body: JSON.stringify({
            userId,
          }),
          headers: {
            "Content-Type": "application/json; charset=UTF-8",
          },
        }
      );
      const result = await response.json();
      if (result.status === 201) {
        let singleData = result.result.find((item) => item._id === PPEditId);

        setPensionProposalData(singleData);
      } else {
        setPensionProposalData([]);
      }
    } catch (error) {
      toast.error("Something failed. Please try again.");
    }
  };

  useEffect(() => {
    getPensionProposalData();
  }, [userId]);

  const tabs = ["Form 1", "Form 2"];
  const [formData, setFormData] = useState({
    fullName: "",
    designation: "",
    officeName: "",
    officeSerialNumber: "",
    hodDesignation: "",
    officerDesignation: "",
    currentDistrict: "",
    birthDateNumber: new Date(),
    birthDateWords: "",
    sevarthID: "",
    age: "",
    appointmentDate: new Date(),
    appointmentDateWords: "",
    firstAppointmentDesig: "",
    firstAppointmentOffice: "",
    ageOnAppointmentDate: "",
    serviceDuration: "",
    retirementType: "",
    retirementDate: new Date(),
    retirementDateWord: "",
    ageOnRetirementDate: "",
    retirementStartDate: "",
    fromDate: new Date(),
    fromNextDate: "",
    toDate: new Date(),
    avgTenMonthSalary: "",
    secondSixMonthSalary: "",
    salaryRange: "",
    baseSalary: "",
    homeRent: "",
    homeRentRange: 0,
    dearnessAllowanceRate: "",
    daRange: 0,
    address: "",
    correspondenceAddress: "",
    mobile: "",
    wifeHusbandName: "",
    height: "",
    identityMark1: "",
    identityMark2: "",
    bankNameBranchAddress: "",
    ifscCode: "",
    accountNumber: "",
    officeToReceivePension: "",
    salaryAccountHead: "",
    cashingOutEarnedLeave: "",
    casteCategory: "",
    gpfNumber: "",
    contributionValueAmt: "",
  });
  const [formData2, setFormData2] = useState({
    fullName: "",
    designation: "",
    officeName: "",
    officeSerialNumber: "",
    hodDesignation: "",
    officerDesignation: "",
    currentDistrict: "",
    birthDateNumber: new Date(),
    birthDateWords: "",
    age: "",
    sevarthID: "",
    appointmentDate: new Date(),
    appointmentDateWords: "",
    firstAppointmentDesig: "",
    firstAppointmentOffice: "",
    ageOnAppointmentDate: "",
    serviceDuration: "",
    retirementType: "",
    retirementDate: new Date(),
    retirementDateWord: "",
    ageOnRetirementDate: "",
    retirementStartDate: "",
    fromDate: new Date(),
    fromNextDate: "",
    toDate: new Date(),
    avgTenMonthSalary: "",
    secondSixMonthSalary: "",
    salaryRange: "",
    baseSalary: "",
    homeRent: "",
    homeRentRange: 0,
    dearnessAllowanceRate: "",
    daRange: 0,
    address: "",
    correspondenceAddress: "",
    mobile: "",
    wifeHusbandName: "",
    height: "",
    identityMark1: "",
    identityMark2: "",
    bankNameBranchAddress: "",
    ifscCode: "",
    accountNumber: "",
    officeToReceivePension: "",
    salaryAccountHead: "",
    cashingOutEarnedLeave: "",
    casteCategory: "",
    gpfNumber: "",
    contributionValueAmt: "",
  });
  console.log(formData);
  console.log(formData2);

  const handleInputChange = (name, marathiValue, englishValue) => {
    setFormData((prev) => ({
      ...prev,
      [name]: marathiValue, // Marathi EditTransliteration
    }));
    setFormData2((prev) => ({
      ...prev,
      [name]: englishValue, // English input
    }));
  };

  const updateFormData = (key, value) => {
    const formattedValue = moment(value).format("DD-MMM-YYYY");
    setFormData((prevData) => ({
      ...prevData,
      [key]: formattedValue,
    }));
    setFormData2((prevData) => ({
      ...prevData,
      [key]: formattedValue,
    }));
  };

  const numberToWords = (num) => {
    const words = [
      "",
      "First",
      "Second",
      "Third",
      "Fourth",
      "Fifth",
      "Sixth",
      "Seventh",
      "Eighth",
      "Ninth",
      "Tenth",
      "Eleventh",
      "Twelfth",
      "Thirteenth",
      "Fourteenth",
      "Fifteenth",
      "Sixteenth",
      "Seventeenth",
      "Eighteenth",
      "Nineteenth",
      "Twentieth",
      "Twenty-first",
      "Twenty-second",
      "Twenty-third",
      "Twenty-fourth",
      "Twenty-fifth",
      "Twenty-sixth",
      "Twenty-seventh",
      "Twenty-eighth",
      "Twenty-ninth",
      "Thirtieth",
      "Thirty-first",
    ];
    return words[num] || num.toString();
  };

  const yearToWords = (year) => {
    const parts = String(year).split("");
    const words = [
      "",
      "One",
      "Two",
      "Three",
      "Four",
      "Five",
      "Six",
      "Seven",
      "Eight",
      "Nine",
    ];
    const tensWords = [
      "",
      "",
      "Twenty",
      "Thirty",
      "Forty",
      "Fifty",
      "Sixty",
      "Seventy",
      "Eighty",
      "Ninety",
    ];
    return `${words[parts[0]]} Thousand ${tensWords[parts[2]]} ${
      words[parts[3]]
    }`;
  };

  const convertDateToText = (dateString) => {
    const months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    // Parse the input date
    const [day, month, year] = dateString.split("-");
    const dayText = numberToWords(parseInt(day, 10));
    const monthText = months.find((m) => m.startsWith(month));
    const yearText = yearToWords(year);

    return `${dayText} ${monthText} ${yearText}`;
  };

  const handleInputDOBDateChange = (value) => {
    const textDate = convertDateToText(moment(value).format("DD-MMM-YYYY"));
    updateFormData("birthDateNumber", value);
    setFormData((prevData) => ({
      ...prevData,
      ["birthDateWords"]: textDate,
    }));
    setFormData2((prevData) => ({
      ...prevData,
      ["birthDateWords"]: textDate,
    }));
  };

  const handleRetirementDateChange = (value) => {
    const currentDate = moment(value, "DD-MM-YYYY").add(1, "days");
    setFormData((prevData) => ({
      ...prevData,
      retirementStartDate: currentDate.format("DD-MM-YYYY"),
    }));
    setFormData2((prevData) => ({
      ...prevData,
      retirementStartDate: currentDate.format("DD-MM-YYYY"),
    }));
    const textDate = convertDateToText(moment(value).format("DD-MMM-YYYY"));
    updateFormData("retirementDate", value);
    setFormData((prevData) => ({
      ...prevData,
      ["retirementDateWord"]: textDate,
    }));
    setFormData2((prevData) => ({
      ...prevData,
      ["retirementDateWord"]: textDate,
    }));
  };

  const handleFromDateDate = (value) => {
    const currentDate = moment(value, "DD-MM-YYYY").add(1, "days");
    setFormData((prevData) => ({
      ...prevData,
      fromNextDate: currentDate.format("DD-MM-YYYY"),
    }));
    setFormData2((prevData) => ({
      ...prevData,
      fromNextDate: currentDate.format("DD-MM-YYYY"),
    }));

    updateFormData("fromDate", value);
  };

  const handleInputAppoDateChange = (value) => {
    const textDate = convertDateToText(moment(value).format("DD-MMM-YYYY"));
    updateFormData("appointmentDate", value);
    setFormData((prevData) => ({
      ...prevData,
      ["appointmentDateWords"]: textDate,
    }));
    setFormData2((prevData) => ({
      ...prevData,
      ["appointmentDateWords"]: textDate,
    }));
  };

  const handleToDate = (value) => {
    updateFormData("toDate", value);
  };

  useEffect(() => {
    const serviceDuration = calculateServiceDuration(
      formData.appointmentDate,
      new Date()
    );

    const ageOnAppointmentDate = calculateServiceDuration(
      formData.birthDateNumber,
      formData.appointmentDate
    );

    const ageOnRetirementDate = calculateServiceDuration(
      formData.birthDateNumber,
      formData.retirementDate
    );

    const updatedData = {
      ...formData,
      serviceDuration,
      ageOnAppointmentDate,
      ageOnRetirementDate,
    };

    setFormData(updatedData);
    setFormData2(updatedData);
  }, [
    formData.appointmentDate,
    formData.birthDateNumber,
    formData.retirementDate,
    formData.avgTenMonthSalary,
  ]);

  // Function to calculate service duration
  const calculateServiceDuration = (appointmentDate, toDate) => {
    if (!appointmentDate) return "";

    const startDate = new Date(appointmentDate);
    const endDate = new Date(toDate); // Current date

    let years = endDate.getFullYear() - startDate.getFullYear();
    let months = endDate.getMonth() - startDate.getMonth();
    let days = endDate.getDate() - startDate.getDate();

    // Adjust days if negative
    if (days < 0) {
      const previousMonth = new Date(
        endDate.getFullYear(),
        endDate.getMonth(),
        0
      ).getDate(); // Days in the previous month
      days += previousMonth;
      months -= 1;
    }

    // Adjust months if negative
    if (months < 0) {
      months += 12;
      years -= 1;
    }

    return `${years} वर्ष, ${months} महिने, ${days} दिवस`;
  };

  const updatePensionProposalData = async () => {
    try {
      const response = await fetch(
        `${api_url}/api/users/update-pension_proposal-data`,
        {
          method: "POST",
          body: JSON.stringify({
            data_id: PPEditId,
            formData,
            formData2,
            familyMember,
            retirementDate: formData.retirementDate,
            appointmentDate: formData.appointmentDate,
            empName: formData.fullName,
            gpfNumber: formData.gpfNumber,
            empDesignation: formData.designation,
            officeName: formData.officeName,
            currentDistrict: formData.currentDistrict,
          }),
          headers: {
            "Content-Type": "application/json; charset=UTF-8",
          },
        }
      );
      const result = await response.json();
      if (result.status === 201) {
        toast.success(result.message);
        setEditDialog(false);
        navigate("/dashboard/pension_proposal");
      } else {
        toast.error(result.message);
      }
    } catch (error) {
      alert(error);
    }
  };

  const [serviceDurationYears, ServiceDurationYears] = useState(0);
  const [serviceDurationMonth, setServiceDurationMonth] = useState(0);
  // Update the home rent whenever formData changes
  useEffect(() => {
    const baseSalary = parseInt(formData.baseSalary);
    setFormData((prev) => ({
      ...prev,
      homeRent: baseSalary * formData.homeRentRange,
    }));
    setFormData2((prev) => ({
      ...prev,
      homeRent: baseSalary * formData.homeRentRange,
    }));

    setFormData((prev) => ({
      ...prev,
      dearnessAllowanceRate: (baseSalary * formData.daRange) / 100,
    }));
    setFormData2((prev) => ({
      ...prev,
      dearnessAllowanceRate: (baseSalary * formData.daRange) / 100,
    }));

    // Function to extract years (वर्ष) as a string
    const getYears = (text) => {
      const parts = text.split(","); // Split by commas
      const yearsPart = parts.find((part) => part.includes("वर्ष")); // Find the part with "वर्ष"

      if (yearsPart) {
        // Extract the number before "वर्ष" using regex
        const match = yearsPart.match(/\d+/); // Match numeric digits
        return match ? parseInt(match[0], 10) : null; // Return the number or null
      }

      return null; // Return null if "वर्ष" is not found
    };
    const getMonths = (text) => {
      const parts = text.split(","); // Split by commas
      const monthsPart = parts.find((part) => part.includes("महिने")); // Find the part with "महिने"

      if (monthsPart) {
        // Extract the number before "महिने" using regex
        const match = monthsPart.match(/\d+/); // Match numeric digits
        return match ? parseInt(match[0], 10) : null; // Return the number or null
      }

      return null; // Return null if "महिने" is not found
    };

    // Example usage:
    const months = getMonths(formData.serviceDuration);

    const years = getYears(formData.serviceDuration);
    setServiceDurationMonth(
      months >= 3 && months < 9 ? 1 : months >= 9 && months < 12 ? 2 : 0
    );
    ServiceDurationYears(years); // Output: "4 वर्ष"
  }, [
    formData.baseSalary,
    formData.homeRentRange,
    formData.daRange,
    formData.retirementDate,
    formData.appointmentDate,
  ]);

  const [familyMember, setfamilyMember] = useState([
    {
      nameMr: "",
      nameEn: "",
      dob: "",
      age: "",
      relation: "",
      maritalStatus: "",
    },
    {
      nameMr: "",
      nameEn: "",
      dob: "",
      age: "",
      relation: "",
      maritalStatus: "",
    },
    {
      nameMr: "",
      nameEn: "",
      dob: "",
      age: "",
      relation: "",
      maritalStatus: "",
    },
    {
      nameMr: "",
      nameEn: "",
      dob: "",
      age: "",
      relation: "",
      maritalStatus: "",
    },
    {
      nameMr: "",
      nameEn: "",
      dob: "",
      age: "",
      relation: "",
      maritalStatus: "",
    },
    {
      nameMr: "",
      nameEn: "",
      dob: "",
      age: "",
      relation: "",
      maritalStatus: "",
    },
  ]);

  useEffect(() => {
    try {
      if (PensionProposalData?.formData) {
        setFormData(JSON.parse(PensionProposalData.formData));
      }
      if (PensionProposalData?.formData2) {
        setFormData2(JSON.parse(PensionProposalData.formData2));
      }
      if (PensionProposalData?.familyMember) {
        setfamilyMember(JSON.parse(PensionProposalData.familyMember));
      }
    } catch (error) {
      console.error("Error parsing JSON data:", error);
    }
  }, [PensionProposalData]);

  // Function to calculate age based on DOB
  const calculateAge = (dob) => {
    if (!dob) return "";
    const birthDate = new Date(dob);
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age;
  };

  const handleFamilyInputChange = (index, field, marathi, value) => {
    const updatedData = [...familyMember];
    if (field === "name") {
      updatedData[index]["nameMr"] = marathi;
      updatedData[index]["nameEn"] = value;
    } else {
      updatedData[index][field] = value;
    }

    // Calculate and update age if DOB is updated
    if (field === "dob") {
      updatedData[index]["age"] = calculateAge(value);
    }

    setfamilyMember(updatedData);
  };

  const [serviceDurationMonth1, setServiceDurationMonth1] = useState(0);

  useEffect(() => {
    setServiceDurationMonth1(
      serviceDurationYears > 33
        ? Math.round(33 * 2)
        : Math.round(serviceDurationYears * 2 + serviceDurationMonth)
    );
  }, [
    formData.birthDateNumber,
    formData.appointmentDate,
    formData.retirementDate,
    serviceDurationYears,
    serviceDurationMonth,
  ]);

  // Define the options data as an array of objects
  const options = [
    { age: 20, value: 9.19 },
    { age: 21, value: 9.187 },
    { age: 22, value: 9.186 },
    { age: 23, value: 9.185 },
    { age: 24, value: 9.184 },
    { age: 25, value: 9.183 },
    { age: 26, value: 9.182 },
    { age: 27, value: 9.18 },
    { age: 28, value: 9.178 },
    { age: 29, value: 9.176 },
    { age: 30, value: 9.173 },
    { age: 31, value: 9.169 },
    { age: 32, value: 9.164 },
    { age: 33, value: 9.159 },
    { age: 34, value: 9.152 },
    { age: 35, value: 9.145 },
    { age: 36, value: 9.136 },
    { age: 37, value: 9.126 },
    { age: 38, value: 9.116 },
    { age: 39, value: 9.105 },
    { age: 40, value: 9.09 },
    { age: 41, value: 9.075 },
    { age: 42, value: 9.059 },
    { age: 43, value: 9.04 },
    { age: 44, value: 9.019 },
    { age: 45, value: 8.996 },
    { age: 46, value: 8.971 },
    { age: 47, value: 8.943 },
    { age: 48, value: 8.913 },
    { age: 49, value: 8.881 },
    { age: 50, value: 8.846 },
    { age: 51, value: 8.808 },
    { age: 52, value: 8.708 },
    { age: 53, value: 8.724 },
    { age: 54, value: 8.678 },
    { age: 55, value: 8.627 },
    { age: 56, value: 8.572 },
    { age: 57, value: 8.512 },
    { age: 58, value: 8.446 },
    { age: 59, value: 8.371 },
    { age: 60, value: 8.284 },
    { age: 61, value: 8.284 },
    { age: 62, value: 8.093 },
    { age: 63, value: 7.982 },
    { age: 64, value: 7.862 },
    { age: 65, value: 7.731 },
    { age: 66, value: 7.591 },
    { age: 67, value: 7.431 },
    { age: 68, value: 7.262 },
    { age: 69, value: 7.083 },
    { age: 70, value: 6.897 },
    { age: 71, value: 6.703 },
    { age: 72, value: 6.502 },
    { age: 73, value: 6.296 },
    { age: 74, value: 6.085 },
    { age: 75, value: 5.872 },
    { age: 76, value: 5.657 },
    { age: 77, value: 5.443 },
    { age: 78, value: 5.229 },
    { age: 79, value: 5.014 },
    { age: 80, value: 4.812 },
    { age: 81, value: 4.611 },
  ];
  // Set the default value based on the retirement age (58)
  useEffect(() => {
    const getYears = (text) => {
      const parts = text.split(","); // Split by commas
      const yearsPart = parts.find((part) => part.includes("वर्ष")); // Find the part with "वर्ष"

      if (yearsPart) {
        // Extract the number before "वर्ष" using regex
        const match = yearsPart.match(/\d+/); // Match numeric digits
        return match ? parseInt(match[0], 10) : null; // Return the number or null
      }

      return null; // Return null if "वर्ष" is not found
    };
    const retirementAge = getYears(formData.ageOnRetirementDate);
    const selectedOption = options.find(
      (option) => option.age === retirementAge + 1
    );
    if (selectedOption) {
      setFormData((prev) => ({
        ...prev,
        contributionValueAmt: selectedOption.value,
      }));
      setFormData2((prev) => ({
        ...prev,
        contributionValueAmt: selectedOption.value,
      }));
    }
  }, [
    formData.birthDateNumber,
    formData.appointmentDate,
    formData.retirementDate,
  ]);

  return (
    <div className="text-start  mx-auto p-lg-4 p-2 bg-info rounded-md shadow-xl gpfnr-input">
      <div className="row">
        <div className="col-lg-2 col-2">
          <h2 className="text-xl fw-bold text-danger text-center">Edit</h2>
        </div>
        <div className="col-lg-9 col-9">
          <h2 className="text-xl fw-bold text-primary text-center">
            सेवानिवृत्ती प्रकरण वैयक्तिक माहिती व सेवा तपशिल / निवृत्ती वेतन
            बाबत माहिती
          </h2>
        </div>
        <div className="col-lg-1  col-1 text-end">
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            onClick={() => setEditDialog(false)}
          ></button>
        </div>
      </div>
      <div className="flex flex-col sm:flex-row border-b-2 gap-3 my-3">
        {tabs.map((tab, index) => (
          <button
            key={index}
            onClick={() => setCurrentStep(index)}
            className={` py-2 px-4 text-xs sm:text-sm w-25 font-semibold text-center 
              ${
                currentStep === index
                  ? "bg-teal-600 text-white"
                  : "bg-orange-100 text-gray-800"
              }
              hover:bg-teal-600 hover:text-white transition-all`}
          >
            {tab}
          </button>
        ))}
      </div>
      {currentStep === 0 && (
        <div className="card px-lg-4 py-lg-4 px-2 py-4 ">
          <div className="row g-2">
            <div className="col-lg-6 mt-2">
              <div>
                <label className="block text-sm font-black text-gray-700 mb-1">
                  कर्मचाऱ्याचे नाव
                </label>
                <EditTransliteration
                  name="fullName"
                  fromDataEnglish={formData2.fullName}
                  fromDataMarathi={formData.fullName}
                  onChange={handleInputChange}
                />
              </div>
            </div>
            <div className="col-lg-6 mt-2">
              <div>
                <label className="block text-sm font-black text-gray-700 mb-1">
                  पदनाव
                </label>
                <EditTransliteration
                  name="designation"
                  fromDataEnglish={formData2.designation}
                  fromDataMarathi={formData.designation}
                  onChange={handleInputChange}
                />
              </div>
            </div>
            <div className="col-lg-4 mt-2">
              <div>
                <label className="block text-sm font-black text-gray-700 mb-1">
                  कार्यालयाचे नाव
                </label>
                <EditTransliteration
                  name="officeName"
                  fromDataEnglish={formData2.officeName}
                  fromDataMarathi={formData.officeName}
                  onChange={handleInputChange}
                />
              </div>
            </div>
            <div className="col-lg-4 col-12 mt-2">
              <div>
                <label className="block text-sm font-black text-gray-700 mb-1">
                  कार्यालयाचा जावक क्रमांक
                </label>
                <EditTransliteration
                  name="officeSerialNumber"
                  fromDataEnglish={formData2.officeSerialNumber}
                  fromDataMarathi={formData.officeSerialNumber}
                  onChange={handleInputChange}
                />
              </div>
            </div>
            <div className="col-lg-4 col-12 mt-2">
              <div>
                <label className="block text-sm font-black text-gray-700 mb-1">
                  कार्यालय प्रमुखाचे पदनाम
                </label>
                <EditTransliteration
                  name="officerDesignation"
                  fromDataEnglish={formData2.officerDesignation}
                  fromDataMarathi={formData.officerDesignation}
                  onChange={handleInputChange}
                />
              </div>
            </div>
            <div className="col-lg-6 mt-2">
              <div>
                <label className="block text-sm font-black text-gray-700 mb-1">
                  विभाग प्रमुखाचे पदनाम
                </label>
                <EditTransliteration
                  name="hodDesignation"
                  fromDataEnglish={formData2.hodDesignation}
                  fromDataMarathi={formData.hodDesignation}
                  onChange={handleInputChange}
                />
              </div>
            </div>
            <div className="col-lg-6 mt-2">
              <div>
                <label className="block text-sm font-black text-gray-700 mb-1">
                  जिल्हा परिषदेचे नाव
                </label>
                <EditTransliteration
                  name="currentDistrict"
                  fromDataEnglish={formData2.currentDistrict}
                  fromDataMarathi={formData.currentDistrict}
                  onChange={handleInputChange}
                />
              </div>
            </div>
            <p className="fw-bold text-start text-danger mt-3 ">सेवेचा तपशिल</p>
            <div className="col-lg-4 col-12 mt-2">
              <div>
                <label className="block text-sm font-black text-gray-700 mb-1">
                  जन्म तारीख
                </label>
                <DatePicker
                  selected={formData.birthDateNumber}
                  onChange={(date) => handleInputDOBDateChange(date)}
                  dateFormat="dd-MMM-yyyy" // Built-in format for DD-MMM-YYYY
                  className="form-control w-100"
                  showMonthDropdown // Enables month dropdown
                  showYearDropdown // Enables year dropdown
                  dropdownMode="select" // Allows selection instead of scrolling
                />
              </div>
            </div>
            <div className="col-lg-4 col-12 mt-2">
              <label className="block text-sm font-black text-gray-700 mb-2">
                प्रथम नेमणूक दिनांक
              </label>
              <DatePicker
                selected={formData.appointmentDate}
                onChange={(date) => handleInputAppoDateChange(date)}
                dateFormat="dd-MMM-yyyy" // Built-in format for DD-MMM-YYYY
                className="form-control w-100"
                showMonthDropdown // Enables month dropdown
                showYearDropdown // Enables year dropdown
                dropdownMode="select" // Allows selection instead of scrolling
              />
            </div>
            <div className="col-lg-4 mt-2">
              <div>
                <label className="block text-sm font-black text-gray-700 mb-1">
                  सेवानिवृत्ती दिनांक
                </label>
                <DatePicker
                  selected={formData.retirementDate}
                  onChange={(date) => handleRetirementDateChange(date)}
                  dateFormat="dd-MMM-yyyy" // Built-in format for DD-MMM-YYYY
                  className="form-control w-100"
                  showMonthDropdown // Enables month dropdown
                  showYearDropdown // Enables year dropdown
                  dropdownMode="select" // Allows selection instead of scrolling
                />
              </div>
            </div>

            <div className="col-lg-4 col-12 mt-2">
              <label className="block text-sm font-black text-gray-700 mb-1">
                जन्म तारीख अक्षरी:
              </label>
              <input
                className="form-control"
                value={formData.birthDateWords}
                readOnly
              />
            </div>
            <div className="col-lg-4 col-12 mt-2">
              <label className="block text-sm font-black text-gray-700 mb-1">
                प्रथम नेमणूक दिनांक अक्षरी:
              </label>
              <input
                className="form-control"
                value={formData.appointmentDateWords}
                readOnly
              />
            </div>

            <div className="col-lg-4 col-12 mt-2">
              <label className="block text-sm font-black text-gray-700 mb-1">
                सेवानिवृत्ती दिनांक अक्षरी:
              </label>
              <input
                className="form-control"
                value={formData.retirementDateWord}
                readOnly
              />
            </div>
            {/* <div className="col-lg-6 col-12 mt-2">
              <label className="block text-sm font-black text-gray-700 mb-2">
                प्रथम नेमणूक पदनाम
              </label>
              <EditTransliteration
                name="firstAppointmentDesig"
                fromDataMarathi={formData && formData.firstAppointmentDesig}
                fromDataEnglish={formData2 && formData2.firstAppointmentDesig}
                onChange={handleInputChange}
              />
            </div>
            <div className="col-lg-6 col-12 mt-2">
              <label className="block text-sm font-black text-gray-700 mb-2">
                प्रथम नेमणूक कार्यालय
              </label>
              <EditTransliteration
                name="firstAppointmentOffice"
                fromDataMarathi={formData && formData.firstAppointmentOffice}
                fromDataEnglish={formData2 && formData2.firstAppointmentOffice}
                onChange={handleInputChange}
              />
            </div> */}
            <div className="col-lg-4 mt-2">
              <label className="block text-sm font-black text-gray-700 mb-1">
                सेवार्थ आयडी
              </label>
              <input
                type="text"
                name="sevarthID"
                value={formData.sevarthID}
                onChange={(e) =>
                  handleInputChange("sevarthID", e.target.value, e.target.value)
                }
                className="form-control capitalize"
              />
            </div>
            <div className="col-lg-4 mt-2">
              <div>
                <label className="block text-sm font-black text-gray-700 mb-1">
                  सेवानिवृत्तीचा प्रकार
                </label>
                <select
                  name="retirementType"
                  className="form-select form-control"
                  onChange={(e) =>
                    handleInputChange(
                      "retirementType",
                      e.target.value,
                      e.target.value
                    )
                  }
                >
                  <option value={formData && formData.retirementType}>
                    {formData && formData.retirementType}{" "}
                  </option>
                  <option value={"स्वेच्छा सेवानिवृत्ती"}>
                    स्वेच्छा सेवानिवृत्ती
                  </option>
                  <option value={"नियत वयोमानानुसार सेवा निवृत्ती"}>
                    नियत वयोमानानुसार सेवा निवृत्ती
                  </option>
                </select>
              </div>
            </div>

            <div className="col-lg-4 mt-2">
              <div>
                <label className="block text-sm font-black text-gray-700 mb-1">
                  सेवानिवृत्ती सुरु दिनांक
                </label>
                <input
                  value={formData.retirementStartDate}
                  className="form-control w-100"
                  readOnly
                />
              </div>
            </div>

            <div className="col-lg-4 col-12 mt-2">
              <label className="block text-sm font-black text-gray-700 mb-2">
                नियुक्तीच्या वेळी असलेले वय
              </label>
              <input
                name="ageOnAppointmentDate"
                value={formData.ageOnAppointmentDate}
                readOnly
                className="form-control"
              />
            </div>
            <div className="col-lg-4 col-12 mt-2">
              <label className="block text-sm font-black text-gray-700 mb-2">
                सेवाकाळ दिवस, महिना व वर्ष
              </label>
              <input
                name="serviceDuration"
                value={formData.serviceDuration}
                readOnly
                className="form-control"
              />
            </div>
            <div className="col-lg-4 col-12 mt-2">
              <label className="block text-sm font-black text-gray-700 mb-2">
                सेवानिवृत्तीचे वय वर्ष
              </label>
              <input
                type="text"
                name="ageOnRetirementDate"
                value={formData.ageOnRetirementDate}
                readOnly
                className="form-control"
              />
            </div>

            <p className="fw-bold text-start text-danger mt-3 ">बँकेचा तपशील</p>
            <div className="col-lg-4 col-6 mt-2">
              <label className="block text-sm font-black text-gray-700 mb-2">
                बँकेचे नाव व शाखा, पत्ता -
              </label>
              <input
                type="text"
                name="bankNameBranchAddress"
                value={formData && formData.bankNameBranchAddress}
                className="form-control"
                onChange={(e) =>
                  handleInputChange(
                    "bankNameBranchAddress",
                    e.target.value,
                    e.target.value
                  )
                }
              />
            </div>
            <div className="col-lg-2 col-6 mt-2">
              <label className="block text-sm font-black text-gray-700 mb-2">
                IFSC Code
              </label>
              <input
                type="text"
                name="ifscCode"
                value={formData && formData.ifscCode}
                className="form-control"
                onChange={(e) =>
                  handleInputChange("ifscCode", e.target.value, e.target.value)
                }
              />
            </div>
            <div className="col-lg-3 col-6 mt-2">
              <label className="block text-sm font-black text-gray-700 mb-2">
                खाते क्रमांक
              </label>
              <input
                type="text"
                name="accountNumber"
                value={formData && formData.accountNumber}
                className="form-control"
                onChange={(e) =>
                  handleInputChange(
                    "accountNumber",
                    e.target.value,
                    e.target.value
                  )
                }
              />
            </div>
            <div className="col-lg-3 col-4 mt-2">
              <label className="block text-sm font-black text-gray-700 mb-2">
                मोबाईल
              </label>
              <input
                type="text"
                name="mobile"
                value={formData && formData.mobile}
                className="form-control"
                onChange={(e) =>
                  handleInputChange("mobile", e.target.value, e.target.value)
                }
              />
            </div>
            <div className="col-lg-6 col-12 mt-2">
              <label className="block text-sm font-black text-gray-700 mb-2">
                सेवा निवृत्ती वेतन घ्यावयाचे कार्यालय
              </label>
              <EditTransliteration
                name="officeToReceivePension"
                fromDataEnglish={formData2 && formData2.officeToReceivePension}
                fromDataMarathi={formData && formData.officeToReceivePension}
                onChange={handleInputChange}
              />
            </div>
            <div className="col-lg-2 col-12 mt-2">
              <label className="block text-sm font-black text-gray-700 mb-2">
                वेतनाचे लेखाशिर्ष
              </label>
              <input
                type="text"
                name="salaryAccountHead"
                value={formData && formData.salaryAccountHead}
                className="form-control"
                onChange={(e) =>
                  handleInputChange(
                    "salaryAccountHead",
                    e.target.value,
                    e.target.value
                  )
                }
              />
            </div>
            <div className="col-lg-4 col-12 mt-2">
              <label
                className="block font-black text-gray-700 mb-2"
                style={{ fontSize: 12 }}
              >
                अर्जित रजा रोखीकरणासाठी शिल्लक असलेले दिवस
              </label>
              <input
                type="text"
                name="cashingOutEarnedLeave"
                value={formData && formData.cashingOutEarnedLeave}
                className="form-control"
                onChange={(e) =>
                  handleInputChange(
                    "cashingOutEarnedLeave",
                    e.target.value,
                    e.target.value
                  )
                }
              />
            </div>
          </div>
        </div>
      )}

      {currentStep === 1 && (
        <div className="card px-2 py-4">
          <div className="row g-2 ">
            <p className="fw-bold text-start text-danger mb-2 text-xl">
              वेतनाचा तपशिल
            </p>
            <div className="col-lg-3 col-6 mt-2">
              <label className="block text-sm font-black text-gray-700 mb-2">
                Avg दहा महिन्याचे वेतन
              </label>
              <input
                type="number"
                name="avgTenMonthSalary"
                value={formData.avgTenMonthSalary}
                onChange={(e) =>
                  handleInputChange(
                    "avgTenMonthSalary",
                    e.target.value,
                    e.target.value
                  )
                }
                className="form-control"
              />
            </div>
            <div className="col-lg-2 col-6 mt-2">
              <label className="block text-sm font-black text-gray-700 mb-2">
                वेतन श्रेणी
              </label>
              <select
                id="salaryRange"
                name="salaryRange"
                onChange={(e) =>
                  handleInputChange(
                    "salaryRange",
                    e.target.value,
                    e.target.value
                  )
                }
                className="form-control form-select"
                required
              >
                <option value={formData && formData.salaryRange}>
                  {formData && formData.salaryRange}
                </option>
                <option value="S-1 : 15000-47600">S-1 : 15000-47600</option>
                <option value="S-2 : 15300-48700">S-2 : 15300-48700</option>
                <option value="S-3 : 16600-52400">S-3 : 16600-52400</option>
                <option value="S-4 : 17100-54000">S-4 : 17100-54000</option>
                <option value="S-5 : 18000-56900">S-5 : 18000-56900</option>
                <option value="S-6 : 19900-63200">S-6 : 19900-63200</option>
                <option value="S-7 : 21700-69100">S-7 : 21700-69100</option>
                <option value="S-8 : 25500-81100">S-8 : 25500-81100</option>
                <option value="S-9 : 26400-83600">S-9 : 26400-83600</option>
                <option value="S-10 : 29200-92300">S-10 : 29200-92300</option>
                <option value="S-11 : 30100-95100">S-11 : 30100-95100</option>
                <option value="S-12 : 32000-101600">S-12 : 32000-101600</option>
                <option value="S-13 : 35400-112400">S-13 : 35400-112400</option>
                <option value="S-14 : 38600-122800">S-14 : 38600-122800</option>
                <option value="S-15 : 41800-132300">S-15 : 41800-132300</option>
                <option value="S-16 : 44900-142400">S-16 : 44900-142400</option>
                <option value="S-17 : 47600-151100">S-17 : 47600-151100</option>
                <option value="S-18 : 49100-155800">S-18 : 49100-155800</option>
                <option value="S-19 : 55100-175100">S-19 : 55100-175100</option>
                <option value="S-20 : 56100-177500">S-20 : 56100-177500</option>
                <option value="S-21 : 57100-180800">S-21 : 57100-180800</option>
                <option value="S-22 : 60000-190800">S-22 : 60000-190800</option>
                <option value="S-23 : 67700-208700">S-23 : 67700-208700</option>
                <option value="S-24 : 71100-211900">S-24 : 71100-211900</option>
                <option value="S-25 : 78800-209200">S-25 : 78800-209200</option>
                <option value="S-27 : 118500-214100">
                  S-27 : 118500-214100
                </option>
                <option value="S-28 : 124800-212400">
                  S-28 : 124800-212400
                </option>
                <option value="S-29 : 131100-216600">
                  S-29 : 131100-216600
                </option>
              </select>
            </div>
            <div className="col-lg-3 col-6 mt-2">
              <label className="block text-sm font-black text-gray-700 mb-2">
                शेवटच्या महिन्याचे वेतन
              </label>
              <input
                type="number"
                id="baseSalary"
                value={formData.baseSalary}
                name="baseSalary"
                onChange={(e) =>
                  handleInputChange(
                    "baseSalary",
                    e.target.value,
                    e.target.value
                  )
                }
                className="form-control"
              />
            </div>

            <div className="col-lg-2 col-6 mt-2">
              <label className="block text-sm font-black text-gray-700 mb-1 d-flex align-items-center  justify-between">
                घरभाडे भत्ता{" "}
                <select
                  id="homeRentRange"
                  name="homeRentRange"
                  onChange={(e) =>
                    handleInputChange(
                      "homeRentRange",
                      e.target.value,
                      e.target.value
                    )
                  }
                  className="form-control w-14 form-select"
                  required
                >
                  <option value={formData && formData.homeRentRange}>
                    {formData && formData.homeRentRange}%
                  </option>
                  <option value={0}>0%</option>
                  <option value={0.09}>9%</option>
                  <option value={0.1}>10%</option>
                  <option value={0.18}>18%</option>
                  <option value={0.2}>20%</option>
                </select>
              </label>
              <input
                type="text"
                name="homeRent"
                value={formData.homeRent}
                onChange={(e) =>
                  handleInputChange("homeRent", e.target.value, e.target.value)
                }
                className="form-control"
              />
            </div>
            <div className="col-lg-2 col-6 mt-2">
              <label className="block text-sm font-black text-gray-700 mb-1 d-flex align-items-center justify-between">
                महागाई भत्ता{" "}
                <input
                  type="number"
                  id="daRange"
                  name="daRange"
                  value={formData && formData.daRange}
                  onChange={(e) =>
                    handleInputChange("daRange", e.target.value, e.target.value)
                  }
                  className="form-control w-14 form-select"
                  required
                />
              </label>
              <input
                type="text"
                value={formData.dearnessAllowanceRate}
                onChange={(e) =>
                  handleInputChange(
                    "dearnessAllowanceRate",
                    e.target.value,
                    e.target.value
                  )
                }
                className="form-control"
              />
            </div>
            <div className="col-lg-12 mt-3">
              <div className="d-flex justify-between">
                <p className="fw-bold text-start text-danger mb-2 text-xl">
                  निवृत्ती वेतन परिगणना तपशील
                </p>
                <Link
                  to={"#"}
                  className="fw-bold text-danger"
                  data-bs-toggle="modal"
                  data-bs-target="#exampleModal"
                >
                  Annexure 1 for Pension
                </Link>
              </div>

              <div
                class="modal fade"
                id="exampleModal"
                tabindex="-1"
                aria-labelledby="exampleModalLabel"
                aria-hidden="true"
              >
                <div class="modal-dialog">
                  <div class="modal-content modal-lg border-2 border-red-700">
                    <div class="modal-header">
                      <h5 class="modal-title" id="exampleModalLabel"></h5>
                      <button
                        type="button"
                        class="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      ></button>
                    </div>
                    <div class="modal-body">
                      <h3 class="text-center">Annexure-I </h3>

                      <p class="text-center">
                        (As referred in paragraph 8.1 of Government Resolution,
                        Finance Department <br />
                        No.PEN-2019/CR 58/SER-4, dated 01 March, 2019. )
                      </p>

                      <h4 class="text-center">
                        COMMUTATION VALUE FOR A PENSION OF Rs.1 PER ANNUM{" "}
                      </h4>
                      <table className="table mt-3">
                        <thead>
                          <tr>
                            <th>Age on next birthday </th>
                            <th>
                              Commutation Value expressed as number of year's
                              purchase{" "}
                            </th>
                            <th>Age on next birthday</th>
                            <th>
                              Commutation Value expressed as number of year's
                              purchase{" "}
                            </th>
                            <th>Age on next birthday</th>
                            <th>
                              Commutation Value expressed as number of year's
                              purchase{" "}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>20</td>
                            <td>9.19</td>
                            <td>41</td>
                            <td>9.075</td>
                            <td>62</td>
                            <td>8.093</td>
                          </tr>
                          <tr>
                            <td>21</td>
                            <td>9.187</td>
                            <td>42</td>
                            <td>9.059</td>
                            <td>63</td>
                            <td>7.982</td>
                          </tr>
                          <tr>
                            <td>22</td>
                            <td>9.186</td>
                            <td>43</td>
                            <td>9.040</td>
                            <td>64</td>
                            <td>7.862</td>
                          </tr>
                          <tr>
                            <td>23</td>
                            <td>9.185</td>
                            <td>44</td>
                            <td>9.019</td>
                            <td>65</td>
                            <td>7.731</td>
                          </tr>
                          <tr>
                            <td>24</td>
                            <td>9.184</td>
                            <td>45</td>
                            <td>8.996</td>
                            <td>66</td>
                            <td>7.591</td>
                          </tr>
                          <tr>
                            <td>25</td>
                            <td>9.183</td>
                            <td>46</td>
                            <td>8.971</td>
                            <td>67</td>
                            <td>7.431</td>
                          </tr>
                          <tr>
                            <td>26</td>
                            <td>9.182</td>
                            <td>47</td>
                            <td>8.943</td>
                            <td>68</td>
                            <td>7.262</td>
                          </tr>
                          <tr>
                            <td>27</td>
                            <td>9.180</td>
                            <td>48</td>
                            <td>8.913</td>
                            <td>69</td>
                            <td>7.083</td>
                          </tr>
                          <tr>
                            <td>28</td>
                            <td>9.178</td>
                            <td>49</td>
                            <td>8.881</td>
                            <td>70</td>
                            <td>6.897</td>
                          </tr>
                          <tr>
                            <td>29</td>
                            <td>9.176</td>
                            <td>50</td>
                            <td>8.846</td>
                            <td>71</td>
                            <td>6.703</td>
                          </tr>
                          <tr>
                            <td>30</td>
                            <td>9.173</td>
                            <td>51</td>
                            <td>8.808</td>
                            <td>72</td>
                            <td>6.502</td>
                          </tr>
                          <tr>
                            <td>31</td>
                            <td>9.169</td>
                            <td>52</td>
                            <td>8.708</td>
                            <td>73</td>
                            <td>6.296</td>
                          </tr>
                          <tr>
                            <td>32</td>
                            <td>9.164</td>
                            <td>53</td>
                            <td>8.724</td>
                            <td>74</td>
                            <td>6.085</td>
                          </tr>
                          <tr>
                            <td>33</td>
                            <td>9.159</td>
                            <td>54</td>
                            <td>8.678</td>
                            <td>75</td>
                            <td>5.872</td>
                          </tr>
                          <tr>
                            <td>34</td>
                            <td>9.152</td>
                            <td>55</td>
                            <td>8.627</td>
                            <td>76</td>
                            <td>5.657</td>
                          </tr>
                          <tr>
                            <td>35</td>
                            <td>9.145</td>
                            <td>56</td>
                            <td>8.572</td>
                            <td>77</td>
                            <td>5.443</td>
                          </tr>
                          <tr>
                            <td>36</td>
                            <td>9.136</td>
                            <td>57</td>
                            <td>8.512</td>
                            <td>78</td>
                            <td>5.229</td>
                          </tr>
                          <tr>
                            <td>37</td>
                            <td>9.126</td>
                            <td>58</td>
                            <td>8.446</td>
                            <td>79</td>
                            <td>5.014</td>
                          </tr>
                          <tr>
                            <td>38</td>
                            <td>9.116</td>
                            <td>59</td>
                            <td>8.371</td>
                            <td>80</td>
                            <td>4.812</td>
                          </tr>
                          <tr>
                            <td>39</td>
                            <td>9.105</td>
                            <td>60</td>
                            <td>8.284</td>
                            <td>81</td>
                            <td>4.611</td>
                          </tr>
                          <tr>
                            <td>40</td>
                            <td>9.090</td>
                            <td>61</td>
                            <td>8.284</td>
                            <td></td>
                            <td></td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-lg-6 col-6">
                  <table>
                    <tbody>
                      <tr>
                        <th>प्रस्तावित सेवा निवृत्ती वेतन</th>
                        <th>{Math.round(formData.baseSalary) || 0}</th>
                        <th>{Math.round(50)}</th>
                        <th>{Math.round(formData.baseSalary * 0.5) || 0}</th>
                      </tr>
                      <tr>
                        <th>प्रस्तावित कुटुंब निवृत्ती वेतन </th>
                        <th>{Math.round(formData.baseSalary) || 0}</th>
                        <th>{Math.round(30)}</th>
                        <th>{Math.round(formData.baseSalary * 0.3) || 0}</th>
                      </tr>
                      <tr>
                        <th>उपदान </th>
                        <th>{Math.round(formData.baseSalary) || 0}</th>
                        <th>{Math.round(serviceDurationYears * 2)}</th>
                        <th>
                          {Math.round(
                            (formData.baseSalary * serviceDurationYears * 2) / 4
                          ) || 0}
                        </th>
                      </tr>
                      <tr>
                        <th>अंशदान निवृत्ती वेतन </th>
                        <th>{Math.round(formData.baseSalary * 0.5) || 0}</th>
                        <th>{Math.round(40)}</th>
                        <th>
                          {Math.round(formData.baseSalary * 0.5 * 0.4) || 0}
                        </th>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div className="col-lg-6 col-6">
                  <table>
                    <tbody>
                      <tr>
                        <th>अंशदान मूल्य रक्कम </th>
                        <th>
                          {Math.round(formData.baseSalary * 0.5 * 0.4) || 0}
                        </th>
                        <th className="w-25">
                          {formData.contributionValueAmt}
                        </th>
                        <th>
                          {Math.round(
                            formData.baseSalary *
                              0.5 *
                              0.4 *
                              formData.contributionValueAmt *
                              12
                          ) || 0}
                        </th>
                      </tr>
                      <tr>
                        <th>अंशराशीकरण वजाजाता नि.वेतन </th>
                        <th>{Math.round(formData.baseSalary * 0.5) || 0}</th>
                        <th>
                          {Math.round(formData.baseSalary * 0.5 * 0.4) || 0}
                        </th>
                        <th>
                          {Math.round(
                            formData.baseSalary * 0.5 -
                              formData.baseSalary * 0.5 * 0.4
                          ) || 0}
                        </th>
                      </tr>
                      <tr>
                        <th>जादा अदाईची वसुली </th>
                        <th>0</th>
                        <th>0</th>
                        <th>0</th>
                      </tr>
                      <tr>
                        <th>गट विमा योजनेचे गृहकर्ज वसुली </th>
                        <th>0</th>
                        <th>0</th>
                        <th>0</th>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <div className="col-lg-12 mt-1">
              <p className="fw-bold text-start text-danger mb-2 text-xl">
                कुटुंबाचा तपशील
              </p>
              <div className="row g-2">
                {/* Headers */}
                <div className="col-12 d-none d-md-flex fw-bold">
                  <div className="col-md-5">नाव</div>
                  <div className="col-md-2">जन्म दिनांक</div>
                  <div className="col-md-1">वय</div>
                  <div className="col-md-2">नाते</div>
                  <div className="col-md-2">वैवाहिक स्थिती</div>
                </div>

                {/* Family Member Rows */}
                {familyMember.map((row, index) => (
                  <div key={index} className="col-12 mb-0">
                    <div className="row g-2 align-items-center">
                      {/* नाव */}
                      <div className="col-12 col-md-5 mb-1 mb-md-0">
                        <label className="d-block d-md-none fw-bold">नाव</label>
                        <EditTransliterationMain
                          index={index}
                          name="name"
                          fromDataEnglish={row.nameEn}
                          fromDataMarathi={row.nameMr}
                          onChange={handleFamilyInputChange}
                        />
                      </div>

                      {/* जन्म दिनांक */}
                      <div className="col-6 col-md-2 mb-1 mb-md-0">
                        <label className="d-block d-md-none fw-bold">
                          जन्म दिनांक
                        </label>
                        <input
                          type="date"
                          className="form-control"
                          name="dob"
                          value={row.dob}
                          onChange={(e) =>
                            handleFamilyInputChange(
                              index,
                              "dob",
                              "dob",
                              e.target.value
                            )
                          }
                        />
                      </div>

                      {/* वय */}
                      <div className="col-6 col-md-1 mb-1 mb-md-0">
                        <label className="d-block d-md-none fw-bold">वय</label>
                        <input
                          type="text"
                          className="form-control"
                          name="age"
                          value={row.age}
                          readOnly
                        />
                      </div>

                      {/* नाते */}
                      <div className="col-6 col-md-2 mb-1 mb-md-0">
                        <label className="d-block d-md-none fw-bold">
                          नाते
                        </label>
                        <select
                          className="form-control form-select"
                          name="relation"
                          value={row.relation}
                          onChange={(e) =>
                            handleFamilyInputChange(
                              index,
                              "relation",
                              "relation",
                              e.target.value
                            )
                          }
                        >
                          <option value="">निवडा</option>
                          <option value="पत्नी">पत्नी</option>
                          <option value="पती">पती</option>
                          <option value="आई">आई</option>
                          <option value="वडिल">वडिल</option>
                          <option value="मुलगा">मुलगा</option>
                          <option value="मुलगी">मुलगी</option>
                        </select>
                      </div>

                      {/* वैवाहिक स्थिती */}
                      <div className="col-6 col-md-2">
                        <label className="d-block d-md-none fw-bold">
                          वैवाहिक स्थिती
                        </label>
                        <select
                          className="form-control form-select"
                          name="maritalStatus"
                          value={row.maritalStatus}
                          onChange={(e) =>
                            handleFamilyInputChange(
                              index,
                              "maritalStatus",
                              "maritalStatus",
                              e.target.value
                            )
                          }
                        >
                          <option value="">निवडा</option>
                          <option value="विवाहित">विवाहित</option>
                          <option value="अविवाहित">अविवाहित</option>
                        </select>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <p className="fw-bold text-danger text-start">
              राहण्याचा व ओळखीचा तपशील
            </p>
            <div className="col-lg-6 mt-2">
              <label className="block text-sm font-black text-gray-700 mb-2">
                राहण्याचे ठिकाण
              </label>
              <EditTransliteration
                name="address"
                fromDataEnglish={formData2.address}
                fromDataMarathi={formData.address}
                onChange={handleInputChange}
              />
            </div>
            <div className="col-lg-6 col-12 mt-2">
              <label className="block text-sm font-black text-gray-700 mb-2">
                पत्र व्यवहाराचा पत्ता
              </label>
              <EditTransliteration
                name="correspondenceAddress"
                fromDataEnglish={formData2.correspondenceAddress}
                fromDataMarathi={formData.correspondenceAddress}
                onChange={handleInputChange}
              />
            </div>
            <div className="col-lg-6 col-12 mt-2">
              <label className="block text-sm font-black text-gray-700 mb-2">
                पतीचे / पत्नीचे नाव
              </label>
              <EditTransliteration
                name="wifeHusbandName"
                fromDataEnglish={formData2.wifeHusbandName}
                fromDataMarathi={formData.wifeHusbandName}
                onChange={handleInputChange}
              />
            </div>
            <div className="col-lg-6 mt-2">
              <div>
                <label className="block text-sm font-black text-gray-700 mb-1">
                  धर्म / जात
                </label>
                <EditTransliteration
                  name="casteCategory"
                  fromDataEnglish={formData2 && formData2.casteCategory}
                  fromDataMarathi={formData && formData.casteCategory}
                  onChange={handleInputChange}
                />
              </div>
            </div>
            <div className="col-lg-2 col-4 mt-2">
              <label className="block text-sm font-black text-gray-700 mb-2">
                उंची <small>(इंच मध्ये)</small>
              </label>
              <input
                type="text"
                name="height"
                value={formData.height}
                className="form-control"
                onChange={(e) =>
                  handleInputChange("height", e.target.value, e.target.value)
                }
              />
            </div>

            <div className="col-lg-2 col-4 mt-2">
              <label className="block text-sm font-black text-gray-700 mb-2">
                भ. नि. नि. क्र.
              </label>
              <input
                type="text"
                name="gpfNumber"
                value={formData.gpfNumber}
                onChange={(e) =>
                  handleInputChange("gpfNumber", e.target.value, e.target.value)
                }
                className="form-control"
              />
            </div>
            <div className="col-lg-4 col-6 mt-2">
              <label className="block text-sm font-black text-gray-700 mb-2">
                ओळख खुणा १
              </label>
              <EditTransliteration
                name="identityMark1"
                fromDataEnglish={formData2.identityMark1}
                fromDataMarathi={formData.identityMark1}
                onChange={handleInputChange}
              />
            </div>
            <div className="col-lg-4 col-6 mt-2">
              <label className="block text-sm font-black text-gray-700 mb-2">
                ओळख खुणा २
              </label>
              <EditTransliteration
                name="identityMark2"
                fromDataEnglish={formData2.identityMark2}
                fromDataMarathi={formData.identityMark2}
                onChange={handleInputChange}
              />
            </div>
          </div>
        </div>
      )}
      <div className="flex justify-between mt-4">
        <button
          onClick={() => setCurrentStep((prev) => Math.max(prev - 1, 0))}
          disabled={currentStep === 0}
          className="bg-blue-300 text-gray-800 px-4 py-2 rounded-lg disabled:opacity-50"
        >
          मागील
        </button>
        {currentStep === tabs.length - 1 ? (
          <button
            onClick={() => updatePensionProposalData()}
            className="bg-blue-600 text-white px-4 py-2 rounded-lg"
          >
            Save
          </button>
        ) : (
          <button
            onClick={() =>
              setCurrentStep((prev) => Math.min(prev + 1, tabs.length - 1))
            }
            disabled={currentStep === tabs.length - 1}
            className="bg-blue-600 text-white px-4 py-2 rounded-lg"
          >
            पुढे
          </button>
        )}
      </div>
    </div>
  );
};

const EditTransliterationMain = ({
  index,
  name,
  fromDataEnglish,
  fromDataMarathi,
  onChange,
}) => {
  const [inputText, setInputText] = useState(""); // English text
  const [transliteratedText, setTransliteratedText] = useState(""); // Marathi text
  useEffect(() => {
    setInputText(fromDataEnglish);
    setTransliteratedText(fromDataMarathi);
  }, [fromDataEnglish]);
  // Function to handle EditTransliteration
  const handleTransliterate = async (text) => {
    const inputLanguage = "mr-t-i0-und"; // 'mr' is for Marathi language
    const maxResult = 8;

    try {
      // Split the input text into words
      const words = text.split(" ");

      const transliteratedWordsSet = new Set();

      for (const word of words) {
        // Create XMLHttpRequest instance
        let request = new XMLHttpRequest();

        // Call Google Transliterate API
        const response = await googleTransliterate(
          request,
          word,
          inputLanguage,
          maxResult
        );

        // Add the first transliterated suggestion to the Set
        if (response && response.length > 0) {
          transliteratedWordsSet.add(response[0][0]);
        }
      }

      // Combine transliterated words
      const transliteratedResult = Array.from(transliteratedWordsSet).join(" ");

      // Update transliterated text
      setTransliteratedText(transliteratedResult);

      // Send values to parent component (Marathi + English)
      onChange(index, name, transliteratedResult, text);
    } catch (error) {
      console.error("EditTransliteration Error: ", error);
    }
  };

  // Handle input change
  const handleInputChange = (e) => {
    // Convert entire input text to uppercase
    const text = e.target.value.toUpperCase(); // Ensure all characters are uppercase
    setInputText(text); // Update English text
    handleTransliterate(text); // Perform EditTransliteration
  };
  const handleKeyDown = (event) => {
    if (event.key === "Tab") {
      event.target.focus();
    }
  };

  return (
    <div className="row g-2">
      <div className="col-lg-6 col-6">
        <input
          type="text"
          value={inputText}
          onChange={handleInputChange}
          onKeyDown={handleKeyDown} // Prevent focus shift on Tab key
          placeholder="Type here in English..."
          className="form-control capitalize text-sm px-2"
        />
      </div>
      <div className="col-lg-6 col-6">
        <p className="form-control text-sm px-1">{transliteratedText}</p>
      </div>
    </div>
  );
};
export default EditPensionProposalData;
